import { AxiosError } from 'axios';
import { baseUrl } from 'lib/constants';
import Api from './qFlowApi';

class Service {
  api: Api;

  constructor() {
    const apiHost =
      process.env.NODE_ENV === 'development'
        ? 'http://localhost:3000'
        : (baseUrl ?? '');
    this.api = new Api(apiHost);
  }

  async getConfigFlow(qflowId: string) {
    try {
      const data = await this.api.get(`/questionflow/${qflowId}`);
      return data;
    } catch (err) {
      const error = err as AxiosError;
      if (error.response && error.response.status === 404) {
        return null;
      }
      throw error;
    }
  }

  async getDynamicQuestions(
    qflowId: string,
    questionCode: string,
    queryString: string
  ) {
    try {
      const data = await this.api.get(
        `/questionflow/${qflowId}/choices/${questionCode}`,
        queryString
      );
      return data;
    } catch (error) {
      throw error;
    }
  }
}

export default Service;
